import React from 'react';

export function ConnectionState({ isConnected }) {
  console.log(isConnected)
  return <p>Connected: { '' + isConnected }</p>;
}